import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js/max';
// Canonical phone validation — the single source of truth for every endpoint that
// writes `users.phone_e164` (ADR-035). Both `/api/auth/me/profile` (self-edit) and
// the admin/platform user-create paths validate identically because they write the
// same column (ADR-009 single-source-of-truth).
//
// Storage is one canonical column: `phone_e164` is the full E.164 string (`+`,
// country calling code, national digits — ≤ 15 digits, so ≤ 16 chars incl. `+`).
// The client composes it from the country picker + national input; the server
// validates the composed E.164. There is no stored region/calling-code — a region
// is derivable from the E.164 for display, and the picker default comes from the
// project's country (ADR-035).
//
// Validation is FORMAT only, and strict per-country: `isValidPhoneNumber` from
// `libphonenumber-js/max` confirms the number matches its country's numbering plan
// (the default `min` metadata validates length only — see ADR-035). It is NOT a
// line-type (mobile/landline) gate: `getNumberType` can't prove SMS-reachability
// and rejects valid numbers; reachability is proven by an OTP verify round-trip at
// send time, not here. Air-gap (ADR-013): validity uses bundled metadata, no network.
export const phoneE164Schema = z
    .string()
    .trim()
    .max(16)
    .refine((v) => isValidPhoneNumber(v), { message: 'invalid phone number' });
// Optional, clearable phone field for request schemas: `null` explicitly clears,
// omission leaves the stored value untouched.
export const phoneE164Field = phoneE164Schema.nullable().optional();
